import { api } from './api';
import { ApiResponse } from './api';

export interface ProductCategory {
  id: number;
  tenantId: number;
  name: string;
  status: string;
  createdAt: string;
  updatedAt?: string;
}

export interface ProductType {
  id: number;
  tenantId: number;
  name: string;
  categoryId: number;
  categoryName: string;
  status: string;
  createdAt: string;
}

export interface StorageRequirement {
  id: number;
  tenantId: number;
  name: string;
  description: string;
  status: string;
  createdAt: string;
  updatedAt?: string;
}

export interface PaginatedResponse<T> {
  items: T[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const masterDataService = {
  // Product Categories
  getProductCategories: async (params?: { 
    page?: number; 
    limit?: number; 
    search?: string; 
    sort?: string; 
    order?: string;
    status?: string;
  }): Promise<ApiResponse<PaginatedResponse<ProductCategory>>> => {
    return api.get('/product-categories', { params });
  },

  createProductCategory: async (data: { 
    name: string; 
    status?: string; 
  }): Promise<ApiResponse<ProductCategory>> => {
    return api.post('/product-categories', data);
  },

  updateProductCategory: async (
    id: number, 
    data: { name?: string; status?: string; }
  ): Promise<ApiResponse<ProductCategory>> => {
    return api.patch(`/product-categories/${id}`, data);
  },

  deleteProductCategory: async (id: number): Promise<ApiResponse<void>> => {
    return api.delete(`/product-categories/${id}`);
  },

  // Product Types
  getProductTypes: async (params?: { 
    page?: number; 
    limit?: number; 
    search?: string; 
    categoryId?: number;
    status?: string;
    sort?: string; 
    order?: string;
  }): Promise<ApiResponse<PaginatedResponse<ProductType>>> => {
    return api.get('/product-types', { params });
  },

  createProductType: async (data: { 
    name: string; 
    categoryId: number;
    status?: string; 
  }): Promise<ApiResponse<ProductType>> => {
    return api.post('/product-types', data);
  },

  updateProductType: async (
    id: number, 
    data: { name?: string; status?: string; }
  ): Promise<ApiResponse<ProductType>> => {
    return api.patch(`/product-types/${id}`, data);
  },

  // Storage Requirements
  getStorageRequirements: async (params?: { 
    page?: number; 
    limit?: number; 
    search?: string; 
    sort?: string; 
    order?: string;
    status?: string;
  }): Promise<ApiResponse<PaginatedResponse<StorageRequirement>>> => {
    return api.get('/storage-requirements', { params });
  },

  createStorageRequirement: async (data: { 
    name: string; 
    description?: string; 
    status?: string; 
  }): Promise<ApiResponse<StorageRequirement>> => {
    return api.post('/storage-requirements', data);
  },

  updateStorageRequirement: async (
    id: number, 
    data: { name?: string; description?: string; status?: string; }
  ): Promise<ApiResponse<StorageRequirement>> => {
    return api.patch(`/storage-requirements/${id}`, data);
  },

  deleteStorageRequirement: async (id: number): Promise<ApiResponse<void>> => {
    return api.delete(`/storage-requirements/${id}`);
  },
};